<template>
    <!-- layer_wrap : S -->
    <div class="layer_pop_wrap">
        <div class='layer_pop_dim' :style="active? 'display: block;' : 'display: none'">
        </div>
        <div class="layer_pop" :class="active? 'active' : ''" data-role-popup="modal_01" tabindex="0">
            <div class="pop_head">
                <h2>포함된 프로토콜</h2>
                <button type="button" class="pop_close" @click="close">닫기</button>
            </div>
            <div class="pop_cont">
                <div class="protocol_search_item">
                    <div class="top_info">
                        <div class="txt_cont">
                            <div class="tit_label">
                                <span v-if="processData?.uniqueNumber" class="label_color color_01" v-html="processData?.uniqueNumber"></span>
                                <span v-else class="label_color color_01" v-html="'공정도'"></span>
                                <span class="label_gray">{{`${processData?.fieldName?.split(">").join(" / ")}`}}</span>
                            </div>
                            <a v-if="$props.searchFlag === true"
                               href="javascript:void(0)" 
                               @click="$emit('goToProcessDetail')" 
                               class="tit_link" 
                               v-html="(!processData?.processName) ? processData?.name : processData?.processName"
                            >
                            </a>
                            <div v-else class="tit_link" v-html="(!processData?.processName) ? processData?.name : processData?.processName">
                            </div>
                            <!--                현재 관리되고 있지 않은 데이터의 경우 빈 화면으로 퍼블리싱 적용 진행.​ -->
                            <!--                영문 한글명 토글 구현시 사용.-->
                            <!--                <p class="txt_info" v-html="processEngName"></p>-->
                            <!--                키워드의 경우 아직 관리되고 있지 않음.-->
                            <!--                <p class="txt_info">Skutterudite, CoSb3, 합성법, 열전소재, 에너지환경</p>-->
                        </div>
                        <div class="img_cont">
                            <a v-if="$props.searchFlag === true" href="javascript:void(0)" @click="$emit('goToProcessDetail')" >
                                <div class="img_box">
                                    <img :src="processData?.thumbnail != null?`data:image/jpeg;base64,${processData?.thumbnail}`:''"
                                         class="template"
                                    />
                                </div>
                            </a>
                            <div v-else class="img_box">
                                <img :src="processData?.thumbnail != null?`data:image/jpeg;base64,${processData?.thumbnail}`:''"
                                     class="template"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="bottom_info">
                        <ul class="user_set">
                            <li>{{lastEditDate}}</li>
                            <li>책임작성자 : {{processData?.userData?.name}}</li>
                            <li v-if="processData?.collaborators?.length">공동작성자 :
                                <span
                                        v-for="(collaborator,collaboratorKey) in processData?.collaborators"
                                        :key="collaboratorKey"
                                >{{`${collaboratorKey != 0 ? " ,"+collaborator.name :collaborator.name}`}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="include_protocol_tit">
                    <span>포함된 프로토콜 <strong>{{ (!protocolList?.length) ? processData?.protocolCount : protocolList?.length}}</strong><em>건</em></span>
                </div>
                <div class="include_protocol_list">
                    <dl class="include_protocol_accodian"
                        v-for="(category,categoryKey) in computedProtocolList"
                        :key="categoryKey"
                        :class="accodianSelection.includes(categoryKey) ? 'open' : null"
                    >
                        <dt @click="accodianSelectionFor(categoryKey)">
                            <ul class="include_protocol_label">
                                <li class="label_01"
                                    v-if="category[0].get('material')?.trim().length != 0"
                                ><span>{{category[0].get('material')}}</span>
                                </li>
                                <li class="label_02"
                                    v-if="category[0].get('measurement')?.trim().length != 0"
                                ><span>{{category[0].get("measurement")}}</span>
                                </li>
                                <li class="label_04"
                                    v-if="category[0].get('analysis')?.trim().length != 0"
                                ><span>{{category[0].get("analysis")}}</span>
                                </li>
                                <li class="label_03"
                                    v-if="category[0].get('equipment')?.trim().length != 0"
                                ><span>{{category[0].get("equipment")}}</span>
                                </li>
                            </ul>
                            <strong class="protocol_num">Protocol ({{category[1]?.length}})</strong>
                        </dt>
                        <dd>
                            <ul class="include_protocol_accodian_list">
                                <li v-for="(protocol,protocolKey) in category[1]"
                                    :key="protocolKey"
                                >
                                    <div class="protocol_search_item">
                                        <!--                                            <label for="chk01" class="component_checkbox">-->
                                        <!--                                                <span>비교하기</span>-->
                                        <!--                                                <input type="checkbox" id="chk01"/>-->
                                        <!--                                            </label>-->
                                        <div class="top_info">
                                            <div class="txt_cont">
                                                <div class="tit_label">
                                                    <span v-if="protocol.uniqueNumber" class="label_color color_02">{{protocol.protocolType}}<em>|</em>{{protocol.uniqueNumber}}</span>
                                                    <span v-else class="label_color color_02">{{protocol.protocolType}}</span>
                                                    <span class="label_gray">{{`${protocol?.fieldName.split(">").join(" / ")}`}}</span>
                                                </div>
                                                <a href="javascript:void(0);" @click="goToDetail(protocol,'tree',1)" class="tit_link" v-html="protocol.name">
                                                </a>
                                                <!--                                                    <p class="txt_info"><span class="highlight">XPS</span> Skutterudite,-->
                                                <!--                                                        CoSb3, 합성법, 열전소재, 에너지환경</p>-->
                                            </div>
                                        </div>
                                        <div class="bottom_info">
                                            <ul class="user_set">
                                                <li v-if="publishingActive">
                                                    {{`${!protocol?.revisionDate?
                                                            protocol?.releaseDate?.substring(0,10).split('-').join('.')
                                                            : protocol?.revisionDate?.substring(0,10).split('-').join('.')}`
                                                    }}
                                                </li>
                                                <li v-else>
                                                    {{`${!protocol?.updatedDate?
                                                            protocol?.createdDate?.substring(0,10).split('-').join('.')
                                                            : protocol?.updatedDate?.substring(0,10).split('-').join('.')}`
                                                    }}
                                                </li>
                                                <li>책임작성자 : {{protocol?.user?.userName}}</li>
                                                <li v-if="protocol?.collaborators.length">공동작성자 :
                                                    <span
                                                            v-for="(collaborator,collaboratorKey) in protocol?.collaborators"
                                                            :key="collaboratorKey"
                                                    >{{`${collaboratorKey != 0 ? " ,"+(collaborator.userName??collaborator.name) : (collaborator.userName??collaborator.name)}`}}</span>
                                                </li>
                                            </ul>
                                            <ul class="btn_set">
                                                <li><a href="javascript:void(0);" class="tree_btn" @click="goToDetail(protocol,'tree',1)">트리보기</a></li>
                                                <li><a href="javascript:void(0);" class="wiki_btn" @click="goToDetail(protocol,'wiki',1)">위키보기</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </dd>
                    </dl>
                </div>
<!--                <NewPagination :pageCnt="1" :pageTotalCnt="1" :size="9" @click="/*search*/"/>-->
            </div>
            <Loading :visible="loading"></Loading>
        </div>
    </div>
    <!-- layer_wrap : E -->
</template>

<script>
    import NewPagination from '@common/NewPagination.vue'
    import Loading from '@common/loading.vue'

    export default {
        props: {
            active: {type: Boolean, default: false},
            inProcessId: {type: Number, default: 0},
            lastEditDate: '',
            publishingActive: {
                type: Boolean, default: false
            },
            searchFlag: {
                type: Boolean, default: false
            }
        },
        components: {
            NewPagination,
            Loading,
        },
        data() {
            return {
                protocolList: [],
                computedProtocols: new Map(),
                categoryMapObj: new Map(),
                computedProtocolList: [],
                accodianSelection: [],
                processData:{},
                loading: false,
            };
        },
        mounted() {
        },
        watch: {
            async active(value) {
                if(!value){
                    return;
                }else {
                    this.resetData();
                    if (this.inProcessId != 0 && this.inProcessId != null) {
                        this.loading = true;
                        let processDetailData = null;
                        // 공정도 정보
                        if(!this.publishingActive) { //myPage
                            processDetailData = await this.$wApi.process.detail(null, this.inProcessId);
                        }else {
                            processDetailData = await this.$wApi.process.release.detail(null,this.inProcessId);    
                        }
                        
                        // 포함된 프로토콜 정보
                        if(!this.publishingActive){ //myPage
                            processDetailData["protocols"] = await this.$wApi.process.getProtocols(null, this.inProcessId);    
                        }
                        
                        // userName setting
                        if(!this.publishingActive) { // myPage 
                            processDetailData["userData"] = processDetailData["user"];
                        }else { // 통합검색
                            processDetailData["userData"] = {name: processDetailData["userName"]};
                        }
                        
                        // Thumbnail 정보
                        let thumbnailData = null;
                        if(!this.publishingActive){
                            thumbnailData = await this.$wApi.process.thumbnail.get(null, this.inProcessId);
                            // Thumbnail setting
                            processDetailData["thumbnail"] = thumbnailData.thumbnail;
                        }

                        if (processDetailData) {
                            this.processData = processDetailData;
                        }
                        if(this.publishingActive){
                            this.protocolList = await this.$wApi.process.release.getValidProtocols(null, this.inProcessId);
                        }else{
                            let protocols = await this.$wApi.process.getProtocols(null, this.inProcessId);
                            if(protocols){
                                protocols = protocols.filter(protocol => protocol.onlyProtocolPublicActive > 0 || protocol.showMode);    
                            }else{
                                protocols = [];
                            }
                            this.protocolList = protocols;
                        }
                        if(this.protocolList?.length != 0) {
                            for(let index=0; index<this.protocolList.length; index++){
                                const protocol = this.protocolList[index];
                                for (const item of Object.entries(protocol)) {
                                    const key = item[0];
                                    switch (key) {
                                        case "uniqueNumber":
                                            let data = protocol["uniqueNumber"]?.split('-');
                                            if(data) {
                                                let len = data.length;
                                                protocol["uniqueNumber"] = [processDetailData["uniqueNumber"], 'F', data[len - 2], data[len - 1]].join('-');
                                            }
                                            break;
                                    }
                                }  
                                if(this.publishingActive) { // 통합검색 (작성자 변수명 맞춰주기 )
                                    protocol["user"] = {userName: protocol["userName"]};
                                }
                            }
                        }
                        if(this.protocolList.length != 0) {
                            this.protocolList.forEach(protocol => {
                                if(protocol["uniqueNumber"]) {
                                    let data = protocol["uniqueNumber"].split('-');
                                    if(data) {
                                        let len = data.length;
                                        protocol["uniqueNumber"] = [processDetailData["uniqueNumber"], 'F', data[len - 2], data[len - 1]].join('-');
                                    }
                                }
                            });
                        }
                        this.loading = false;
                    }
                }
            },
            async protocolList(value) {
                if (value?.length != 0 && value != null) {
                    await this.computeCategory(value);
                }
            },
        },
        methods: {
            close() {
                this.$emit("close");
            },
            // 재료, 목적, 장비별로 그룹화 하는 함수.
            async computeCategory(protocolList) {
                this.loading = true;
                for (let index = 0; index < protocolList.length; index++) {
                    const protocol = protocolList[index];
                    let categoryMap = new Map();
                    if (index == 0) {
                        const categoryId = "category" + this.categoryMapObj.size;
                        categoryMap.set("analysis", protocol.analysis);
                        categoryMap.set("equipment", protocol.equipment);
                        categoryMap.set("material", protocol.material);
                        categoryMap.set("measurement", protocol.measurement);
                        this.categoryMapObj.set(categoryId, categoryMap);
                        this.computedProtocols.set(categoryId, [protocol]);
                        continue;
                    } else {
                        let categoryKey = null;
                        for (let map of this.categoryMapObj) {
                            let key = map[0];
                            let value = map[1];
                            if (value.get("analysis") == protocol.analysis
                                && value.get("equipment") == protocol.equipment
                                && value.get("material") == protocol.material
                                && value.get("measurement") == protocol.measurement
                            ) {
                                categoryKey = key;
                                break;
                            }
                        }
                        if (categoryKey) {
                            let tempMap = this.computedProtocols.get(categoryKey);
                            tempMap.push(protocol)
                            this.computedProtocols.set(categoryKey, tempMap);
                        } else {
                            const categoryId = "category" + this.categoryMapObj.size;
                            categoryMap.set("analysis", protocol.analysis);
                            categoryMap.set("equipment", protocol.equipment);
                            categoryMap.set("material", protocol.material);
                            categoryMap.set("measurement", protocol.measurement);
                            this.categoryMapObj.set(categoryId, categoryMap);
                            this.computedProtocols.set(categoryId, [protocol]);
                        }
                    }
                }
                for (let map of this.categoryMapObj) {
                    let key = map[0];
                    let value = map[1];
                    let result = [];
                    result.push(value);
                    result.push(this.computedProtocols.get(key));
                    this.computedProtocolList.push(result);
                }
                this.loading = false;
            },
            accodianSelectionFor(accodianIndex) {
                if (this.accodianSelection.includes(accodianIndex)) {
                    this.accodianSelection = this.accodianSelection.filter((item) => item !== accodianIndex);
                } else {
                    this.accodianSelection.push(accodianIndex);
                }
            },
            goToDetail(protocol,viewMode,tabIndex){
                const protocolId = protocol.protocolId;
                if(this.publishingActive) { // 통합
                    if(protocol.publicActive > 1){
                        if(this.user.admin || this.user.assistant || this.user.committee || this.user.generalManager || this.user.super){
                            this.$emit("goToDetail",protocolId,viewMode,tabIndex);
                        }else{
                            window.alert("위원/간사 이상 조회 가능한 프로토콜 입니다.");
                        }
                    }else {
                        this.$emit("goToDetail", protocolId, viewMode, tabIndex);
                    }
                }else {
                    this.$emit("goToDetail",protocolId,viewMode,tabIndex);
                }
            },
            resetData(){
                this.protocolList = [];
                this.computedProtocols = new Map();
                this.categoryMapObj = new Map();
                this.computedProtocolList = [];
                this.accodianSelection = [];
                this.processData ={};
                this.loading = false;
            }
        },
    };
</script>
